import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5940a6d1")

_pushScopeId("data-v-5940a6d1")
const _hoisted_1 = {
  key: 0,
  class: "ranking"
}
const _hoisted_2 = { class: "ranking-bg-cover" }
const _hoisted_3 = { class: "ranking-body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "ranking-heading" }, "現在のランキング", -1)
const _hoisted_5 = { class: "period" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "space-bg-gradation" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "ranking-user-lists"
}
const _hoisted_8 = { class: "top-rank-list" }
const _hoisted_9 = { class: "ranking2" }
const _hoisted_10 = { class: "ranking1" }
const _hoisted_11 = { class: "ranking3" }
const _hoisted_12 = {
  key: 0,
  class: "ranking-user-lists"
}
const _hoisted_13 = { class: "top-rank-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RankingSecond = _resolveComponent("RankingSecond")
  const _component_RankingFirst = _resolveComponent("RankingFirst")
  const _component_RankingThird = _resolveComponent("RankingThird")
  const _component_LPRankingUser = _resolveComponent("LPRankingUser")

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.state.date), 1),
            _hoisted_6,
            (_ctx.isTallying)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_RankingSecond, {
                        name: "集計中",
                        score: "0",
                        path: ""
                      })
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_RankingFirst, {
                        name: "集計中",
                        score: "0",
                        path: ""
                      })
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_RankingThird, {
                        name: "集計中",
                        score: "0",
                        path: ""
                      })
                    ])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(Math.max(_ctx.maxCount - 3, 0), (index) => {
                    return (_openBlock(), _createBlock("p", null, [
                      _createVNode(_component_LPRankingUser, {
                        name: "集計中",
                        score: "0",
                        path: "",
                        index: index - 1
                      }, null, 8, ["index"])
                    ]))
                  }), 256))
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.event.startDate < new Date())
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode("div", _hoisted_13, [
                          _createVNode(_component_RankingSecond, {
                            name: _ctx.state.rankingUsers[1].influencer.influencer.displayName,
                            score: _ctx.state.rankingUsers[1].influencer.points ?? 0,
                            path: _ctx.state.rankingUsers[1].influencer.influencer.mainImage
                          }, null, 8, ["name", "score", "path"]),
                          _createVNode(_component_RankingFirst, {
                            class: "ranking1",
                            name: _ctx.state.rankingUsers[0].influencer.influencer.displayName,
                            score: _ctx.state.rankingUsers[0].influencer.points ?? 0,
                            path: _ctx.state.rankingUsers[0].influencer.influencer.mainImage
                          }, null, 8, ["name", "score", "path"]),
                          _createVNode(_component_RankingThird, {
                            name: _ctx.state.rankingUsers[2].influencer.influencer.displayName,
                            score: _ctx.state.rankingUsers[2].influencer.points ?? 0,
                            path: _ctx.state.rankingUsers[2].influencer.influencer.mainImage
                          }, null, 8, ["name", "score", "path"])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.rankingUsers.slice(3, _ctx.maxCount), (user, index) => {
                          return (_openBlock(), _createBlock("p", null, [
                            _createVNode(_component_LPRankingUser, {
                              name: user.influencer.influencer.displayName,
                              score: user.influencer.points ?? 0,
                              path: user.influencer.influencer.mainImage,
                              index: index
                            }, null, 8, ["name", "score", "path", "index"])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})